import types from './types.json';
import modes from './modes.json';

export default {
  types,
  modes,
};
